// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8292309","455":"5267a14d","977":"399da43b"}[chunkId] + ".chunk.js";
};